import type { Store } from "redux";
import { selectOrderLineLocation } from "../planningTable/selectors";
import {
    UPDATE_LINE_ORDER_ACTION_NAME,
    UPDATE_UNSCHEDULED_ORDER,
    type UpdateLineOrderAction,
    type UpdateUnscheduledOrder,
} from "./index";
import type { ReduxState } from "../reducers";

type UpdateOrderCommentAction = UpdateLineOrderAction | UpdateUnscheduledOrder;

export const createUpdateOrderCommentAction = (
    state: ReduxState,
    order_uuid: string,
    comment: string
): UpdateOrderCommentAction | null => {
    const located = selectOrderLineLocation(state, order_uuid);
    if (!located) {
        return null;
    }

    const updated_order = { ...located.order, order_comment: comment };

    if (located.is_unscheduled) {
        return {
            type: UPDATE_UNSCHEDULED_ORDER,
            data: { order: updated_order, run_quick_simulation: false },
        };
    }

    return {
        type: UPDATE_LINE_ORDER_ACTION_NAME,
        data: {
            line_uuid: located.line_uuid,
            order_uuid,
            order: updated_order,
            run_quick_simulation: false,
        },
    };
};

export const dispatchUpdateOrderComment = (store: Store<ReduxState>, order_uuid: string, comment: string): void => {
    const action = createUpdateOrderCommentAction(store.getState(), order_uuid, comment);
    if (action) {
        store.dispatch(action);
    }
};
